import React from "react";
import { motion } from "framer-motion";
import { MapPin, Phone, Clock, MessageCircle } from "lucide-react";
import { CONTACT, HOURS } from "../../lib/constants";

const MAP_EMBED =
  "https://www.google.com/maps?q=R.%20Mato%20Grosso%2C%202565%20-%20Kiosque%2003%20-%20Centro%20Norte%2C%20Sorriso%20-%20MT%2C%2078890-000&output=embed";

export const Location = () => {
  return (
    <section id="localizacao" className="relative py-20 md:py-28 bg-bege" data-testid="location-section">
      <div id="contato" className="absolute -top-20" aria-hidden="true" />

      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-14"
        >
          <div className="text-xs tracking-[0.35em] uppercase text-gold font-semibold mb-3">venha nos visitar</div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-bordo font-semibold" data-testid="location-title">
            Localização & <span className="italic">Contato</span>
          </h2>
          <div className="gold-ornament mt-5" />
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-10 items-stretch">
          {/* Map */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="rounded-2xl overflow-hidden shadow-xl border-2 border-gold/40 min-h-[380px]"
            data-testid="location-map-wrapper"
          >
            <iframe
              src={MAP_EMBED}
              title="Mapa do Restaurante O Padrinho"
              loading="lazy"
              className="w-full h-full min-h-[380px] border-0"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </motion.div>

          {/* Info */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="bg-white rounded-2xl shadow-xl border border-gold/30 p-8 md:p-10 flex flex-col"
            data-testid="location-info-card"
          >
            <ul className="space-y-7 flex-1">
              <li className="flex items-start gap-4" data-testid="location-address">
                <div className="w-11 h-11 rounded-full bg-bordo/10 flex items-center justify-center flex-shrink-0">
                  <MapPin size={20} className="text-bordo" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-gold font-semibold mb-1">Endereço</div>
                  <p className="text-dark/85 leading-relaxed">{CONTACT.address}</p>
                </div>
              </li>

              <li className="flex items-start gap-4" data-testid="location-phone">
                <div className="w-11 h-11 rounded-full bg-bordo/10 flex items-center justify-center flex-shrink-0">
                  <Phone size={20} className="text-bordo" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-gold font-semibold mb-1">Telefone</div>
                  <a href={`tel:+${CONTACT.whatsapp}`} className="text-dark/85 hover:text-bordo transition-colors">
                    {CONTACT.whatsappDisplay}
                  </a>
                </div>
              </li>

              <li className="flex items-start gap-4" data-testid="location-hours">
                <div className="w-11 h-11 rounded-full bg-bordo/10 flex items-center justify-center flex-shrink-0">
                  <Clock size={20} className="text-bordo" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-gold font-semibold mb-2">Horários</div>
                  <ul className="space-y-1.5">
                    {HOURS.map((h, i) => (
                      <li key={i} className="text-dark/85 text-sm md:text-base">
                        <span className="font-semibold">{h.days}:</span> {h.time}
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            </ul>

            <a
              href={CONTACT.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp mt-8 inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 font-semibold text-base self-start"
              data-testid="location-whatsapp-cta"
            >
              <MessageCircle size={18} fill="currentColor" strokeWidth={0} />
              Chamar no WhatsApp
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Location;
